import { apiClient as api } from './api';
import { callV3, type ApiResponse } from '../api/envelope';
import type {
  LabDescriptor,
  LabsListResponse,
  StudioDefinition,
  StudiosListResponse,
} from '../domain';

const STUDIOS = '/api/v3/studios';
const LABS = '/api/v3/labs';

export const StudioService = {
  listStudios: (labId?: string) =>
    callV3<StudiosListResponse>(
      api.get<ApiResponse<StudiosListResponse>>(STUDIOS, {
        params: labId ? { labId } : undefined,
      }),
    ),

  getStudio: (studioId: string) =>
    callV3<StudioDefinition>(
      api.get<ApiResponse<StudioDefinition>>(`${STUDIOS}/${studioId}`),
    ),

  listLabs: () =>
    callV3<LabsListResponse>(api.get<ApiResponse<LabsListResponse>>(LABS)),

  getLab: (labId: string) =>
    callV3<LabDescriptor>(api.get<ApiResponse<LabDescriptor>>(`${LABS}/${labId}`)),
};
